import { useAuth } from '../hooks/useAuth';

export default function Dashboard() {
     const { user } = useAuth();

     return (
          <div>
               <h2 className="h4 mb-4 text-gray-800">
                    Welcome to Radiology TLD Management
               </h2>

               {user && (
                    <div className="row">
                         <div className="col-12">
                              <div className="card shadow mb-4">
                                   <div className="card-header py-3">
                                        <h6 className="m-0 font-weight-bold text-primary">User Information</h6>
                                   </div>
                                   <div className="card-body">
                                        <p><strong>Name:</strong> {user.name || 'N/A'}</p>
                                        <p><strong>Email:</strong> {user.email || 'N/A'}</p>
                                        <p><strong>Role:</strong> {user.role || 'N/A'}</p>
                                        <p><strong>User Code:</strong> {user.user_code || 'N/A'}</p>
                                   </div>
                              </div>
                         </div>
                    </div>
               )}

               <div className="row">
                    <div className="col-xl-3 col-md-6 mb-4">
                         <div className="card border-left-primary shadow h-100 py-2">
                              <div className="card-body">
                                   <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                             <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                                  Total Badges
                                             </div>
                                             <div className="h5 mb-0 font-weight-bold text-gray-800">42</div>
                                        </div>
                                        <div className="col-auto">
                                             <i className="fas fa-medal fa-2x text-gray-300"></i>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>

                    <div className="col-xl-3 col-md-6 mb-4">
                         <div className="card border-left-success shadow h-100 py-2">
                              <div className="card-body">
                                   <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                             <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                                                  Completed Training
                                             </div>
                                             <div className="h5 mb-0 font-weight-bold text-gray-800">18</div>
                                        </div>
                                        <div className="col-auto">
                                             <i className="fas fa-check-circle fa-2x text-gray-300"></i>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>

                    <div className="col-xl-3 col-md-6 mb-4">
                         <div className="card border-left-info shadow h-100 py-2">
                              <div className="card-body">
                                   <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                             <div className="text-xs font-weight-bold text-info text-uppercase mb-1">
                                                  In Progress
                                             </div>
                                             <div className="row no-gutters align-items-center">
                                                  <div className="col-auto">
                                                       <div className="h5 mb-0 mr-3 font-weight-bold text-gray-800">6</div>
                                                  </div>
                                             </div>
                                        </div>
                                        <div className="col-auto">
                                             <i className="fas fa-spinner fa-2x text-gray-300"></i>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>

                    <div className="col-xl-3 col-md-6 mb-4">
                         <div className="card border-left-warning shadow h-100 py-2">
                              <div className="card-body">
                                   <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                             <div className="text-xs font-weight-bold text-warning text-uppercase mb-1">
                                                  Pending Review
                                             </div>
                                             <div className="h5 mb-0 font-weight-bold text-gray-800">3</div>
                                        </div>
                                        <div className="col-auto">
                                             <i className="fas fa-clock fa-2x text-gray-300"></i>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
          </div>
     );
}
